import { AttachmentTypeId } from '../../core';
import { from, Observable } from 'rxjs';

export class FileUtils {
  static fileToB64(file: File): Observable<string> {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    const resultPromise = new Promise<string>((resolve, reject) => {
      reader.onload = event => resolve(event.target?.result as string);
      reader.onerror = error => reject(error);
    });
    return from(resultPromise);
  }

  static getFileSizeString(sizeInBytes: number): string {
    const sizeInKb = sizeInBytes / 1000;
    const sizeInMb = sizeInKb / 1000;

    if (sizeInMb >= 1) {
      return $localize`${sizeInMb.toFixed(2)} MB`;
    } else {
      return $localize`${sizeInKb.toFixed(2)} KB`;
    }
  }

  static getAttachmentTypeFromFile(file: File): AttachmentTypeId {
    const imageTypes = ['image/png', 'image/jpeg'];
    const pdfTypes = ['application/pdf'];

    const mimeType = file.type.toLowerCase();
    if (imageTypes.includes(mimeType)) {
      return AttachmentTypeId.Image;
    } else if (pdfTypes.includes(mimeType)) {
      return AttachmentTypeId.PDF;
    } else {
      return AttachmentTypeId.Doc;
    }
  }

  static openFileInNewTab(file: File): void {
    const fileReader = new FileReader();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    fileReader.onload = (e: any) => {
      const fileContent = e.target.result;
      const blob = new Blob([fileContent], { type: file.type });
      const objectUrl = URL.createObjectURL(blob);

      window.open(objectUrl);
      URL.revokeObjectURL(objectUrl);
    };

    fileReader.readAsArrayBuffer(file);
  }

  static isFileSizeValid(file: File, maxSizeInBytes: number = FileUtils.maxFileSizeInBytes): boolean {
    return file.size <= maxSizeInBytes;
  }

  static readonly maxFileSizeInMB = 3;
  static readonly maxFileSizeInBytes = FileUtils.maxFileSizeInMB * 1000 * 1000;
}
